import React, { useState, useEffect, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { UsersContext } from 'contexts';
import { Button, Form, Typography } from 'components';
import { Container } from 'layouts';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  roleGroupLabel: {
    fontWeight: 'bold'
  },
  roleLabel: {
    fontSize: '14px'
  }
}));

const EditUserForm = (props) => {
  const classes = useStyles();

  const { actions } = useContext(UsersContext);

  const [roles, setRoles] = useState([]);

  useEffect(() => {
    (async () => {
      setRoles(await actions.getRoles());
    })();
  }, [actions, setRoles]);

  const Checkbox = (checkboxProps) => (
    <Form.Checkbox {...checkboxProps} classesLabel={{label: classes.roleLabel}}/>
  );

  const renderRoles = useCallback(() => {
    return roles.map((rolesByBusinessUnit) => {
      return (
        <Container key={rolesByBusinessUnit.business_unit}>
          <Typography className={classes.roleGroupLabel}>
            {rolesByBusinessUnit.label}
          </Typography>
          {rolesByBusinessUnit.roles.map((role) => {
            return (
              <Field
                key={role.value}
                type="checkbox"
                label={role.label}
                name="roles"
                fullWidth
                value={role.value}
                onChange={props.handleChange}
                component={Checkbox}
              />
            );
          })}
        </Container>
      );
    });
  }, [roles, props.values.roles]);

  return (
    <div className={classes.paper}>
      <Form className={classes.form} onSubmit={props.handleSubmit} noValidate>
        <Form.TextField
          variant="outlined"
          margin="normal"
          fullWidth
          id="email"
          label="Email Address"
          name="email"
          autoFocus
          onChange={props.handleChange}
          value={props.values.email}
          error={props.errors.email && props.touched.email}
          helperText={
            props.errors.email && props.touched.email
              ? props.errors.email
              : false
          }
        />
        <Form.TextField
          variant="outlined"
          margin="normal"
          fullWidth
          name="password"
          label="New Password"
          type="password"
          id="password"
          onChange={props.handleChange}
          value={props.values.password}
          error={props.errors.password && props.touched.password}
          helperText={
            props.errors.password && props.touched.password
              ? props.errors.password
              : false
          }
        />
        {renderRoles()}
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          Save
        </Button>
      </Form>
    </div>
  );
};

EditUserForm.propTypes = {
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  isSubmitting: PropTypes.bool,
  setSubmitting: PropTypes.func,
};

export default EditUserForm;
